<template>
  <div>
    <div class="vx-row mx-2">
      <div class="router-header flex flex-wrap items-center mb-6">
        <div
          class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light"
        >
          <h2 class="mb-1">ติดตั้งอุปกรณ์</h2>
        </div>
        <!-- <p class="mx-5 mt-2">เรือในโครงการ</p> -->
      </div>
    </div>
    <vx-card>
      <div class="px-5 pb-5 relative">
        <div class="flex">
          <div class="flex justify-start absolute mt-2">
            <vs-button
              v-if="$acl.check('hasRoleSuperVisor') && supervisorType != 'APPROVER' "
              color="primary"
              type="gradient"
              icon-pack="feather"
              icon="icon-plus"
              to="/vessel/registration-vessel"
            >
              ลงทะเบียนเรือ
            </vs-button>

            <!-- <DownloadExcel :data="vessels" :fields="json_fields" name="fisheries-oil-registration.xls" >
              <vs-button
                class="mx-2"
                color="primary"
                type="gradient"
                icon-pack="feather"
                icon="icon-download-cloud"
              >
                ดาวน์โหลด
              </vs-button>
            </DownloadExcel> -->
          </div>
        </div>
        <vs-table
          :data="vessels"
          search
          max-items="10"
          pagination
          class="text-center"
        >
          <template slot="thead">
            <vs-th sort-key="id"><p class="mx-auto">ลำดับ</p></vs-th>
            <vs-th sort-key="vessel.mmsi"><p class="mx-auto">MMSI</p></vs-th>
            <vs-th sort-key="vessel.exciseOilCode"><p class="mx-auto text-center">ทะเบียนเรือสรรพสามิต</p></vs-th>
            <vs-th sort-key="vessel.name"><p class="mx-auto">ชื่อเรือ</p></vs-th>
            <vs-th sort-key="type"><p class="mx-auto">ประเภทเรือ</p></vs-th>
            <vs-th sort-key="createdAt" ><p class="mx-auto">วันที่ลงทะเบียน</p></vs-th>
            <vs-th><p class="mx-auto text-center">เขตพื้นที่</p></vs-th>
            <vs-th><p class="mx-auto text-center">ลงทะเบียนโดย</p></vs-th>
            <vs-th><p class="mx-auto">สถานะ</p></vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="indextr">
                {{ indextr + 1 }}
              </vs-td>

              <vs-td :data="data[indextr].vessel.mmsi">
                <a @click="detailVessel(data[indextr].id)">{{
                  data[indextr].vessel.mmsi
                }}</a>
              </vs-td>

              <vs-td :data="data[indextr].vessel.exciseOilCode">
                <a @click="detailVessel(data[indextr].id)">{{
                  data[indextr].vessel.exciseOilCode
                }}</a>
              </vs-td>

              <vs-td :data="data[indextr].vessel.name">
                <a @click="detailVessel(data[indextr].id)">{{
                  data[indextr].vessel.name
                }}</a>
              </vs-td>

              <vs-td :data="data[indextr].vessel.type">
                {{ data[indextr].vessel.type == 'vessel' ? 
                "เรือประมง" : data[indextr].vessel.type == 'tanker' ? 
                "เรือบรรทุกน้ำมัน" : data[indextr].vessel.type == 'serialTanker'? 
                "เรือบรรทุกน้ำมันต่อเนื่อง" : "สถานีบริการน้ำมัน" }}
              </vs-td>

              <vs-td :data="data[indextr].createdAt">
                {{ formateDate(data[indextr].createdAt) }}
              </vs-td>

              <vs-td :data="data[indextr].vessel.zone.province">
                {{ data[indextr].vessel.zone.province }}
              </vs-td>

              <vs-td :data="data[indextr].registrationBy">
                {{ data[indextr].registrationBy }}
              </vs-td>

              <vs-td :data="data[indextr].status" style="width: 200px">
                <div class="align-middle flex justify-center" >
                  <vs-dropdown color="#c80948" >
                    <vs-chip v-if="data[indextr].status == 'แจ้งรับอุปกรณ์ติดตั้งเรือ'" color="#ffe1c5" > <!-- TODO : color #ffd5ae -->
                      <!-- TODO : get receiveDate last index -->
                      <p style="color: #000"> แจ้งรับอุปกรณ์ติดตั้งเรือ {{ formateDate(data[indextr].accessoriesReceives[0].receiveDate) }} </p>
                    </vs-chip>
                    <vs-chip v-else-if="data[indextr].status == 'ยืนยันการรับอุปกรณ์ติดตั้งเรือ'">
                      ยืนยันการรับอุปกรณ์ติดตั้งเรือ
                    </vs-chip>
                    <vs-chip v-else-if="data[indextr].status == 'รอการติดตั้งอุปกรณ์'" color="#fc7e2a">
                      <p style="color: #fff"> รอการติดตั้งอุปกรณ์</p>
                    </vs-chip>
                    <vs-chip v-else-if="data[indextr].status == 'รอยืนยันการติดตั้งอุปกรณ์'">
                      <p style="color: #000"> รอยืนยันการติดตั้งอุปกรณ์</p>
                    </vs-chip>
                    <vs-chip v-else-if="data[indextr].status == 'ยืนยันการติดตั้งอุปกรณ์'" color="#188d09">
                      <p style="color: #fff"> ยืนยันการติดตั้งอุปกรณ์</p>
                    </vs-chip>
                    
                    <vs-dropdown-menu v-if="data[indextr].status == 'แจ้งรับอุปกรณ์ติดตั้งเรือ'" style="min-width: 10rem">
                      <vs-dropdown-item @click="receiveEquipment(data[indextr].id, 'ยืนยันการรับอุปกรณ์ติดตั้งเรือ')">
                        รับอุปกรณ์
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                    <vs-dropdown-menu v-else-if="data[indextr].status == 'รอการติดตั้งอุปกรณ์'"> <!-- data[indextr].registrationBy == 'กรมสรรพสามิตพื้นที่' || (data[indextr].registrationBy == 'ผู้ดูแลระบบ' &&  -->
                      <vs-dropdown-item @click="equipmentInstall(data[indextr].id, data[indextr].installations[0].id, 'ยืนยันการติดตั้งอุปกรณ์')">
                        ติดตั้งอุปกรณ์
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                    <vs-dropdown-menu v-else-if="data[indextr].status == 'รอยืนยันการติดตั้งอุปกรณ์'">
                      <vs-dropdown-item @click="confirmInstall(data[indextr].id, data[indextr].installations[0].id, 'ยืนยันการติดตั้งอุปกรณ์' )">
                        ยืนยันการติดตั้งอุปกรณ์
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>

    <div class="demo-alignment">
      <vs-popup
        title="ยืนยันการรับอุปกรณ์ติดตั้งเรือ"
        :active.sync="popupReceive"
      >
        <registration-receive
          v-if="popupReceive"
          @onClosedRecieve="onClosedRecieve"
          :dataVessel="passData"
          :active="popupReceive"
        ></registration-receive>
      </vs-popup>
    </div>

    <div class="demo-alignment">
      <vs-popup
        id="popup-signature"
        title="ยืนยันการติดตั้งอุปกรณ์"
        :active.sync="popupInstall"
      >
        <registration-install
          v-if="popupInstall"
          @onClosedInstall="onClosedInstall"
          :dataVessel="passInfo"
          :active="popupInstall"
        ></registration-install>
      </vs-popup>
    </div>

    <div class="demo-alignment">
      <vs-popup
        id="popup-signature"
        title="ยืนยันการติดตั้งอุปกรณ์"
        :active.sync="popupConfirmInstall"
      >
        <registration-confirm-install
          v-if="popupConfirmInstall"
          @onClosedConfirmInstall="onClosedConfirmInstall"
          :dataVessel="passInfo"
          :active="popupConfirmInstall"
        ></registration-confirm-install>
      </vs-popup>
    </div>

    <div class="demo-alignment">
      <vs-popup
        id="popup-signature"
        class="popup"
        title="ลายเซนต์"
        :active.sync="signaturePopup"
      >
        <registration-popup
          @onClosedSignature="onClosedSignature"
          :passValue="passId"
        ></registration-popup>
      </vs-popup>
    </div>

  </div>
</template>

<script>
import RegistrationReceive from "./../registrationVessel/admin/registrationReceive.vue";
import RegistrationInstall from "./../registrationVessel/admin/registrationInstall.vue";
import RegistrationConfirmInstall from "./../registrationVessel/admin/registrationConfirmInstall.vue";
import Swal from "sweetalert2";
import moment from "moment";
import RegistrationPopup from "./../registrationVessel/registration-popup/RegistrationPopup.vue";
import VueSignaturePad from "vue-signature-pad";
import { AclRule } from "vue-acl";
import DownloadExcel from "vue-json-excel";

export default {
  name: "VesselIndex",
  components: {
    RegistrationInstall,
    RegistrationReceive,
    RegistrationConfirmInstall,
    RegistrationPopup,
    VueSignaturePad,
    DownloadExcel
  },
  computed: {
    isLocalRule() {
      return new AclRule("create").generate();
    },
  },
  data() {
    return {
      name: "tony stark",
      cardId: "1234567890123",
      phoneNumber: "091-747-9231",
      eMail: "test123@gmail.com",
      postalCode: "40000",
      district: "เชียงยืน",
      subDistrict: "เชียงยืน",
      province: "มหาสารคาม",
      homeNumber: "1234",
      chkStatus: true,
      popupConfirmInstall: false,
      popupInstall: false,
      popupReceive: false,
      status: [
        { text: "รอยืนยันการลงทะเบียนเรือ", value: 1 },
        { text: "ยืนยันการลงทะเบียนเรือ", value: 2 },
        { text: "แจ้งรับอุปกรณ์ติดตั้งเรือ", value: 3 },
        { text: "ยืนยันการรับอุปกรณ์ติดตั้งเรือ", value: 4 },
        { text: "รอการติดตั้งอุปกรณ์", value: 5 },
        { text: "รอยืนยันการติดตั้งอุปกรณ์", value: 6 },
        { text: "ยืนยันการติดตั้งอุปกรณ์", value: 7 },
      ],
      registerInfo: [
        { text: "เจ้าของเรือ", value: 1 },
        { text: "กรมสรรพสามิตพื้นที่", value: 2 },
      ],
      search: {
        mmsi: "",
        name: "",
        status: "",
        registerBy: "",
      },
      selected: [],
      vessels: [],
      passInfo: null,
      passData: null,
      passId: null,
      signaturePopup: false,
      isSignaturePad: false,
      companySealImage: null,
      supervisorType: localStorage.getItem('exciseType'),
      isConfirmedRegistration: true,
      isDownload: false,
      json_fields: {
        'MMSI': "vessel.mmsi",
        'ทะเบียนเรือสรรพสามิต': "vessel.exciseOilCode",
        'ชื่อเรือ': "vessel.name",
        'ประเภทเรือ': {
          field: "vessel.type",
          callback: (value) => {
            const type = value == 'vessel' ? 
                "เรือประมง" : value == 'tanker' ? 
                "เรือบรรทุกน้ำมัน" : value == 'serialTanker'? 
                "เรือบรรทุกน้ำมันต่อเนื่อง" : "สถานีบริการน้ำมัน"
            return type;
          },
        },
        'วันที่ลงทะเบียน': {
          field: "createdAt",
          callback: (value) => {
            return this.formateDate(value);
          },
        },
        'เขตพื้นที่': "vessel.zone.province",
        'ลงทะเบียนโดย': "registrationBy",
        'สถานะ': "status",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  mounted() {
    this.getData();
    console.log("supervisorType ", this.supervisorType);
  },
  watch: {},
  methods: {
    async getData() {
      this.$vs.loading({});
      await this.$store.dispatch("installAccessories/getRegistrationForInstallation");
      this.vessels = this.$store.state.installAccessories.registrationsForInstallation;
      this.$vs.loading.close();
    //   console.log("this.vessels ", this.vessels);
    },
    detailVessel(id) {
      this.$router.push(`/vessel/detail/${id}`);
    },
    confirmRecieve(id, value) {
      Swal.fire({
        title: "ยืนยันการลงทะเบียนเรือ",
        text: "",
        icon: "question",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        preConfirm: () => {
          var payload = {
            id: id,
            value: value,
          };
          this.$store.dispatch("vessels/setChangeStatus", payload);
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            icon: "success",
            title: "ยืนยันการลงทะเบียนเรือเรียบร้อยแล้ว",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {});
        }
      });
    },
    cancelRecieve(id, value) {
      Swal.fire({
        title: "ยกเลิกการยืนยันทะเบียนเรือ",
        text: "",
        icon: "warning",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        preConfirm: () => {
          var payload = {
            id: id,
            value: value,
          };
          this.$store.dispatch("vessels/setChangeStatus", payload);
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            icon: "success",
            title: "ยกเลิกการยืนยันทะเบียนเรือเรียบร้อยแล้ว",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {});
        }
      });
    },
    equipmentInstall(registrationId, installId, value) {
      this.popupInstall = true;
      this.passInfo = { registrationId, installId, value };
    },
    onClosedInstall(val) {
      this.popupInstall = false;
      this.getData();
    },
    confirmInstall(registrationId, installId, value) {
      this.popupConfirmInstall = true;
      this.passInfo = { registrationId, value };
    },
    onClosedConfirmInstall(val) {
      this.popupConfirmInstall = false;
      this.getData();
    },
    onClosedSignature(val) {
      this.signaturePopup = false;
    },
    async cancelRegister(id) {
      Swal.fire({
        title: "ยืนยันยกเลิกการลงทะเบียน",
        text: "",
        icon: "question",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        preConfirm: () => {
          const data = {
            registrationId: id,
            status: "ยกเลิกการลงทะเบียน",
            mmsi: null,
          };
          this.$store.dispatch("vessels/setChangeStatus", data);
        },
      });
    },
    async comfirmRegister(id,installations, vessel) {
      await this.$store.dispatch("users/setUserById", {
        id: localStorage.getItem("accessUserId"),
      });

      const user = await this.$store.state.users.user;
      console.log("id สรรพสามิตพื้นที่ ===> ", id);

      if (this.$acl.check('hasRoleAdmin')) {
        Swal.fire({
          title: "ยืนยันการลงทะเบียน",
          text: "",
          icon: "question",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showCancelButton: true,
          preConfirm: () => {
            const data = {
              registrationId: id,
              status: "ยืนยันการลงทะเบียนเรือ",
              fileName: user.signatureName,
              detail: null,
              installations
            };
            if (user.signatureName != "" && user.signatureName != null) {
              this.$store.dispatch("vessels/setChangeStatus", data);
            } else {
              this.passId = {
                id,
                name: "ยืนยันการลงทะเบียนเรือ",
                type: "registration_user",
                data,
              };
              this.signaturePopup = !this.signaturePopup;
            }
          },
        })
      } else {
         if (this.supervisorType != "APPROVER") {
          // if (vessel.mmsi) {
          //   var mmsi = vessel.mmsi
          // } else {
          //   var { value: mmsi } =  await Swal.fire({
          //     title: "ยืนยันการลงทะเบียนเรือ",
          //     input: "text",
          //     inputLabel: "MMSI",
          //     confirmButtonText: 'ต่อไป',
          //     cancelButtonText: 'ยกเลิก',
          //     showCancelButton: true,
          //     inputValidator: (value) => {
          //       if (!value) {
          //         return "กรุณากรอก MMSI เพื่อยืนยันการลงทะเบียนเรือ";
          //       }
          //       if (value.length != 9) {
          //         return "กรุณากรอก MMSI ให้ครบ 9 หลักเท่านั้น";
          //       }
          //       if (!Number(value)) {
          //         return "กรุณากรอก MMSI เป็นตัวเลขเท่านั้น";
          //       }
          //     },
          //   })
          // }

          // if (mmsi) {//&& registrationExcise //เลขทะเบียนเรือสรรพสามิต
          var { value: datail } = await Swal.fire({
            title: "ความเห็นเจ้าพนักงาน",
            input: 'textarea',
            inputPlaceholder: 'ความเห็นเจ้าพนักงาน(ไม่จำเป็นต้องกรอก)',
            showCancelButton: false,
            confirmButtonText: 'ต่อไป',
          }).then((result)=>{
            Swal.fire({
              title: "ยืนยันการลงทะเบียน",
              text: "",
              icon: "question",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "ยืนยัน",
              cancelButtonText: "ยกเลิก",
              showCancelButton: true,
              preConfirm: () => {
                const data = {
                  registrationId: id,
                  status: "ยืนยันการลงทะเบียนเรือ",
                  fileName: user.signatureName,
                  // mmsi,
                  detail: result.value,
                  installations
                  // registrationExcise //เลขทะเบียนเรือสรรพสามิต
                };
                if (user.signatureName != "" && user.signatureName != null) {
                  this.$store.dispatch("vessels/setChangeStatus", data);
                } else {
                  this.passId = {
                    id,
                    name: "ยืนยันการลงทะเบียนเรือ",
                    type: "registration_user",
                    data,
                  };
                  this.signaturePopup = !this.signaturePopup;
                }
              },
            })
          });
          // } 
        } else {
          Swal.fire({
            title: "ยืนยันการลงทะเบียน",
            text: "",
            icon: "question",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
            showCancelButton: true,
            preConfirm: () => {
              const data = {
                registrationId: id,
                status: "ยืนยันการลงทะเบียนเรือ",
                fileName: user.signatureName,
                mmsi: null,
                detail: null,
                installations
              };
              if (user.signatureName != "" && user.signatureName != null) {
                this.$store.dispatch("vessels/setChangeStatus", data);
              } else {
                this.passId = {
                  id,
                  name: "ยืนยันการลงทะเบียนเรือ",
                  type: "registration_user",
                  data,
                };
                this.signaturePopup = !this.signaturePopup;
              }
            },
          })
        }
        
      }
      
      // เลขทะเบียนเรือสรรพสามิต
      // var { value: registrationExcise } = await Swal.fire({
      //   title: "ยืนยันการลงทะเบียนเรือ",
      //   input: "number",
      //   inputLabel: "เลขทะเบียนเรือสรรพสามิต",
      //   inputValidator: (value) => {
      //     if (!value) {
      //       return "กรุณากรอก เลขทะเบียนเรือสรรพสามิต เพื่อยืนยันการลงทะเบียนเรือ";
      //     }
      //     if (value.length != 10) {
      //       return "กรุณากรอก เลขทะเบียนเรือสรรพสามิต ให้ครบ 10 หลักเท่านั้น";
      //     }
      //   },
      // });
 

    },
    async receiveEquipment(id, value) {
      this.passData = { id, value };
      console.log("data pss :", this.passData);
      this.popupReceive = true;
    },
    onClosedRecieve() {
      this.popupReceive = false;
      this.getData();
    },
    formateDate(date) {
      return date && moment(date).add(543, "year").format("DD/MM/YYYY");
    },
    print(id, type) {
      window.open(`/admin/vessel/${type}/print/${id}`, "_blank");
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
      this.isSignaturePad = false;
    },
    convertDataUrlToBlob(dataUrl) {
      const arr = dataUrl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new Blob([u8arr], { type: mime });
    },
    checkSignature(signatures){
      this.supervisorType == 'null' && (this.supervisorType = null)
      let signaturesSupervisors = []
      signatures.map((signature)=>{
        // console.log(signature.user.exciseType, this.supervisorType);
        if (signature.type == 'เจ้าพนักงานสรรพสามิต') {
          if (signature.user.exciseType == this.supervisorType) {
            signaturesSupervisors.push(signature)
          }
        }
      })
      // console.log(signaturesSupervisors.length);
      return signaturesSupervisors.length != 1 
    },
    async addMMSI(registrationForm , vessel){
      console.log(registrationForm , vessel);

      // เลขMMSI
      var { value: mmsi } = await Swal.fire({
        title: "ยืนยันการเพิ่ม MMSI",
        input: "text",
        inputLabel: "MMSI",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "กรุณากรอก MMSI";
          }
          if (value.length != 9) {
            return "กรุณากรอก MMSI ให้ครบ 9 หลักเท่านั้น";
          }
        },
      });

      if (mmsi) {
        const data = {
          vesselId: vessel.id,
          mmsi
        }
        this.$store.dispatch("vessels/addMMSI", data);
      }

    },
    async fetchData(){
      const response = await axios.get('https://holidayapi.com/v1/holidays?key=a4b2083b-1577-4acd-9408-6e529996b129&country=US&year=2017&month=09');
      console.log(response);
      return response.data.holidays;
    },
    startDownload(){
        alert('show loading');
    },
    finishDownload(){
        alert('hide loading');
    }
  }
};
</script>

<style lang="css" scoped></style>
